import axios from 'axios';

export const axiosWi = axios.create({
	baseURL: 'https://api.recity.in/api/',
	headers: { 'Content-Type': 'application/json' },
});
